import Loader from 'components/Loader/Loader.component';
import React, { lazy, Suspense } from 'react';

interface Props {
  fallback: React.ReactNode | null;
}

const loadable = <T extends React.ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
  { fallback = null }: Props = { fallback: null },
) => {
  const LazyComponent = lazy(importFunc);

  const SuspenseComponent = (props: React.ComponentProps<T>) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );

  return SuspenseComponent;
};

const loadablePageOptions = {
  fallback: (
    <Loader
      viewMode="fluid"
      overlayViewMode="fullscreen"
      active
      animationDelayMs={100}
    />
  ),
};

export const loadablePage = <T extends React.ComponentType<any>>(
  importFunc: () => Promise<{ default: T }>,
) => loadable<T>(importFunc, loadablePageOptions);

export default loadable;
